// Vite entrypoint for iframe pack
console.log('Vite ⚡️ Rails - Starting iframe_pack')

// Import jQuery first and expose to window
// This MUST be first to ensure jQuery is globally available before any other scripts
import '../helpers/expose-jquery'

// Import Rails UJS, Turbolinks and ActiveStorage
import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'

// Start Rails services
if (!window._rails_loaded) {
  Rails.start()
  window._rails_loaded = true
}
if (!window._turbolinks_loaded) {
  Turbolinks.start()
  window._turbolinks_loaded = true
}
if (!window._activestorage_loaded) {
  ActiveStorage.start()
  window._activestorage_loaded = true
}

// Import controllers for Stimulus
import '../controllers/index.js'


// Font styles
import '@fontsource/rubik/300.css'
import '@fontsource/rubik/400.css'
import '@fontsource/rubik/500.css'